export default "__VITE_ASSET__Neelxv2g__"